import React from 'react';
import { Nav, Navbar } from 'rsuite';
import { Link, useLocation } from 'react-router-dom';
import Affix from 'rsuite/Affix';
import Footer from 'rsuite/Footer';

const AppFooter = () => {
  return (
    <Affix>
      <Footer> </Footer>
    </Affix>
  );
};

export default AppFooter;
